module.exports = __webpack_public_path__ + "static/media/02.b2e2a960.jpg";